export const goToRoot = () => {
  window.location.assign(
    window.location.href.replace(window.location.pathname, '/auth/'),
  );
};
